const mockImage = new Blob(
    [
        new Uint8Array([
            71, 73, 70, 56, 57, 97, 1, 0, 1, 0, 0, 0, 0, 33, 249, 4, 1, 10, 0,
            1, 0, 44, 0, 0, 0, 0, 1, 0, 1, 0, 0, 2, 2, 76, 1, 0, 59,
        ]),
    ],
    { type: 'image/gif' },
);

export const getMockImageUrl = () => URL.createObjectURL(mockImage);
